import type { Candidate } from "@/interfaces/candidates";
import { portalJobsService } from "@/services/portal_jobs";
import { defineStore } from "pinia";
import { ref } from "vue";
import { useRouter } from "vue-router";

export const useAuthCandidateStore = defineStore('authCandidate', () => {

    const token = ref("");
    const candidate = ref<Candidate>();
    const router = useRouter();

    const loadCandidate = async (reload: boolean = false) => {
        if (!candidate.value || reload) {
            const data = await portalJobsService.candidateInfo();
            candidate.value = data;
        }
        return candidate.value;
    };

    const logout = () => {
        token.value = "";
        candidate.value = undefined;
        router.push({ name: 'portalJobs' });
        portalJobsService.logout();
    }

    return {
        token,
        loadCandidate,
        logout,
        candidate
    }

})